import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const inlineContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  overflow: 'hidden'
};

export const textStyle: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 1,
  minWidth: 0
};

export const nameStyle: CSSProperties = {
  textAlign: 'center',
  width: '100%',
  color: '#FFF',
  fontSize: '15px',
  fontWeight: '600',
  position: 'absolute',
  bottom: '0px',
  padding: '10px 0px',
  background:
    'linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0) 100%)'
};

export const imgStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};

export const premiumUpsellCardContainerStyle: CSSProperties = {
  position: 'relative',
  width: '100%',
  height: '220px',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  backgroundColor: '#f9f9f9',
  cursor: 'pointer',
  gap: '18px'
};

export const premiumUpsellHeartContainerStyle: CSSProperties = {
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const premiumUpsellTextStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '500',
  color: '#000',
  opacity: 0.5,
  padding: '5px 10px 5px 10px'
};

export const premiumUpsellButtonStyle: CSSProperties = {
  backgroundColor: '#000',
  color: '#fff',
  padding: '8px 24px',
  fontSize: '16px',
  fontWeight: 600,
  borderRadius: '20px',
  width: '70%'
};

export const buttonStyle: CSSProperties = {
  position: 'absolute',
  top: '14px',
  right: '14px',
  borderRadius: '25px',
  width: '35px',
  height: '35px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 0px 2px 0px #00000040'
};

export const reactionButtonStyle: CSSProperties = {
  ...buttonStyle,
  background: UIConfig.Colors.PrimaryGradient
};

export const likeButtonStyle: CSSProperties = {
  ...buttonStyle,
  border: '2px solid #ffffff',
  background: 'rgb(0 0 0 / 30%)'
};
